import React, { useEffect } from "react";
import { useNavContext } from "../../context-api/nav-context";
import QuestThree from "../../components/quote-components/quoteQuestions/QuestThree";

const QuestionThree = () => {
  const { closeNavbarMenu } = useNavContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main onMouseOver={closeNavbarMenu}>
      <QuestThree />
    </main>
  );
};

export default QuestionThree;
